import React from 'react';
import ReactDOM from 'react-dom/client';
import './providers/i18n';
import './index.css';
import App from './app';
import { Provider } from 'react-redux';
import { store } from './core/redux/store';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
